import React from 'react';

import { TextButton } from '@components/Button/variants';
import IconDeepResearchDoubleSparkle from '@components/Images/DeepResearch/IconDeepResearchDoubleSparkle';
import IconClose from '@components/Images/Rebranding/IconClose';
import SearchIcon from '@components/Images/SearchIcon';
import { upgrade_subscription_path } from '@routes';

import StepNavigation from '../StepNavigation';

interface DeepResearchAndSearchProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

export const SearchSection = () => (
  <div className="flex flex-col gap-4">
    <div className="flex items-center gap-8">
      <h2 className="my-0 font-suisse-screen text-headline-alt-sm font-medium text-white">
        Search
      </h2>
      <SearchIcon className="h-16 w-16 text-primary-magenta" />
    </div>
    <p className="my-0 font-suisse-screen text-byline-lg text-white">
      Search our extensive article library.
    </p>
  </div>
);

const DEEP_RESEARCH_DESCRIPTION =
  'For in-depth insights, try our AI-powered tool—built with over a decade of The Information’s reporting & analysis.';

export const DeepResearchSection = ({ showUpgradeLink }: { showUpgradeLink: boolean }) => (
  <div className="flex flex-col gap-4">
    <div className="flex items-center gap-8">
      <h2 className="my-0 font-suisse-screen text-headline-alt-sm font-medium text-white">
        Deep Research
      </h2>
      <IconDeepResearchDoubleSparkle className="h-16 w-16 text-pro-gold" />
    </div>
    <p className="my-0 font-suisse-screen text-byline-lg text-white">{DEEP_RESEARCH_DESCRIPTION}</p>
    {showUpgradeLink && (
      <TextButton
        as="link"
        href={upgrade_subscription_path()}
        className="w-fit font-suisse-screen text-byline-lg text-white"
      >
        Upgrade to Pro
      </TextButton>
    )}
  </div>
);

const DeepResearchAndSearch = ({
  handleClose,
  handleNext,
  isProSubscriber,
  step,
  totalSteps,
}: DeepResearchAndSearchProps) => {
  return (
    <div className="relative w-[416px] bg-grayscale-charcoal px-32 py-24">
      <button
        type="button"
        className="absolute right-12 top-12 cursor-pointer touch-manipulation border-none bg-transparent p-0 text-white"
        onClick={handleClose}
        aria-label="Close"
      >
        <IconClose className="stroke-2" height={12} width={12} />
      </button>
      <div className="flex flex-col gap-32">
        {isProSubscriber ? (
          <>
            <DeepResearchSection showUpgradeLink={false} />
            <SearchSection />
          </>
        ) : (
          <>
            <SearchSection />
            <DeepResearchSection showUpgradeLink />
          </>
        )}
      </div>
      <StepNavigation
        handleNext={handleNext}
        isProSubscriber={isProSubscriber}
        step={step}
        stepCounterClassName="text-grayscale-beige"
        totalSteps={totalSteps}
      />
    </div>
  );
};

export default DeepResearchAndSearch;
